import { render, staticRenderFns } from "./ModalInfo.vue?vue&type=template&id=b1ecd8b4&scoped=true&"
import script from "./ModalInfo.vue?vue&type=script&lang=js&"
export * from "./ModalInfo.vue?vue&type=script&lang=js&"
import style0 from "./ModalInfo.vue?vue&type=style&index=0&id=b1ecd8b4&scoped=true&lang=css&"
import style1 from "./ModalInfo.vue?vue&type=style&index=1&id=b1ecd8b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1ecd8b4",
  null
  
)

export default component.exports